/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { BuilderFormSchemaFactory, FormRootSchema, FormStateSchema } from '@gh/builder-shared';
import {
  FormState,
  whenEditMode,
} from '@gh/common-shared';
import {
  FormMode,
} from '@gh/core-ui';
import { PbBulkUpdateICMarkup } from '../../resources/pb-bulk-update-markup.model';

@Injectable()
export class PbBulkUpdateICMarkupFormState extends FormState<PbBulkUpdateICMarkup> {
  private basicInfo: PbBulkUpdateICMarkup;

  constructor(private schemaFactory: BuilderFormSchemaFactory) {
    super(schemaFactory);
  }

  buildSchema(info: PbBulkUpdateICMarkup, { root }: FormStateSchema): FormRootSchema {
    const mode = FormMode.EditMode;

    return root({
      mode,
      enabled: whenEditMode(),
      optimisticLock: true,
      children: {
        itemMarkup: void 0,
        compMarkup: void 0,
        deletePct: void 0,
        costCenter: void 0,
      },
    });
  }

  build(basicInfo: PbBulkUpdateICMarkup): void {
    this.basicInfo = basicInfo;

    this.initSchema(basicInfo);
  }
}
